import { TFunction } from 'i18next';
import { z } from 'zod';
import { BIRTHDAY_MIN, getBirthdayMax, toLocalCalendarDate } from '@/utils/birthday';

export const onboardingSchemaBasicInformation = (t: TFunction<'translation', undefined>) =>
  z.object({
    first_name: z
      .string()
      .min(1, { message: t('first_name_required') })
      .max(50, { message: t('first_name_length') }),
    last_name: z
      .string()
      .min(1, { message: t('last_name_required') })
      .max(50, { message: t('last_name_length') }),
    birthday: z
      .date({ message: t('birthdate_required') })
      .refine((date) => toLocalCalendarDate(date).compare(BIRTHDAY_MIN) >= 0, { message: t('birthdate_invalid') })
      .refine((date) => toLocalCalendarDate(date).compare(getBirthdayMax()) <= 0, { message: t('age_restriction') }),
  });

export type OnboardingSchemaBasicInformationType = z.infer<ReturnType<typeof onboardingSchemaBasicInformation>>;

export const onboardingSchemaAddressInformation = (t: TFunction<'translation', undefined>) =>
  z.object({
    state: z
      .string()
      .min(2, { message: t('state_min_length') })
      .max(50, { message: t('state_max_length') })
      .transform((str) => str.trim()),
    postcode: z
      .string()
      .min(3, { message: t('postal_code_min_length') })
      .max(30, { message: t('postal_code_max_length') })
      .transform((str) => str.trim()),
    city: z
      .string()
      .min(2, { message: t('city_min_length') })
      .max(50, { message: t('city_max_length') })
      .transform((str) => str.trim()),
    address: z
      .string()
      .min(5, { message: t('address_min_length') })
      .max(100, { message: t('address_max_length') })
      .transform((str) => str.trim()),
  });

export type OnboardingSchemaAddressInformationType = z.infer<ReturnType<typeof onboardingSchemaAddressInformation>>;

export enum OnboardingSteps {
  MISSING_VERIFICATION = 1,
  MISSING_BASIC_INFORMATION = 2,
  MISSING_ADDRESS_INFORMATION = 3,
}
